import { ShieldCheck } from "lucide-react";
import Logo from "@/components/Logo";

const ClientTopBar = ({ agency = null }) => {
  return (
    <header className="sticky top-0 z-30 bg-white/85 backdrop-blur-xl border-b border-[#EEF2F5]">
      <div className="max-w-md mx-auto px-5 h-14 flex items-center justify-between">
        <div className="flex items-center gap-2 min-w-0">
          <Logo variant="full" size="xs" rounded="rounded-md" testId="client-topbar-logo" />
          {agency?.name && (
            <>
              <span className="text-[#D1D5DB]">·</span>
              <span className="text-[11.5px] font-medium text-[#6B7280] truncate">
                {agency.name}
              </span>
            </>
          )}
        </div>
        <span
          data-testid="client-secure-badge"
          className="inline-flex items-center gap-1 rounded-full bg-[#D9FFE8] px-2 py-0.5 text-[10.5px] font-semibold text-[#111111]"
        >
          <ShieldCheck size={10} strokeWidth={2.25} />
          Sécurisé
        </span>
      </div>
    </header>
  );
};

export default ClientTopBar;
